module.exports = __webpack_public_path__ + "img/q6.b3047810.png";